import { render } from "./AllTenderSubmissions.vue?vue&type=template&id=67b2e960&scoped=true"
import script from "./AllTenderSubmissions.vue?vue&type=script&lang=js"
export * from "./AllTenderSubmissions.vue?vue&type=script&lang=js"

import "./AllTenderSubmissions.vue?vue&type=style&index=0&id=67b2e960&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b2e960"]])

export default __exports__